import { render, staticRenderFns } from "./StatementOfAccount.vue?vue&type=template&id=650128e8"
import script from "./StatementOfAccount.vue?vue&type=script&lang=js"
export * from "./StatementOfAccount.vue?vue&type=script&lang=js"
import style0 from "./StatementOfAccount.vue?vue&type=style&index=0&id=650128e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports